export default "__VITE_ASSET__50a0cecb__"